/* Download enhancement; ordinary PDF links remain available without JavaScript. */
(() => {
  if (window.mnsAcademyV2Downloads) return;
  window.mnsAcademyV2Downloads = true;
  document.addEventListener('click', async (event) => {
    const link = event.target.closest('[data-mns2-download]');
    if (!link || event.button !== 0 || event.metaKey || event.ctrlKey || event.shiftKey || event.altKey) return;
    event.preventDefault();
    if (link.getAttribute('aria-busy') === 'true') return;
    const status = link.closest('.mns2__document').querySelector('[role="status"]');
    link.setAttribute('aria-busy', 'true');
    status.textContent = 'Preparazione del PDF…';
    const controller = new AbortController();
    const timer = setTimeout(() => controller.abort(), 20000);
    try {
      const response = await fetch(link.href, { credentials: 'omit', signal: controller.signal });
      if (!response.ok) throw new Error('PDF unavailable');
      const blob = await response.blob();
      const signature = await blob.slice(0, 5).text();
      if (signature !== '%PDF-') throw new Error('Invalid PDF');
      const objectUrl = URL.createObjectURL(new Blob([blob], { type: 'application/pdf' }));
      const anchor = document.createElement('a');
      anchor.href = objectUrl;
      anchor.download = link.getAttribute('download') || 'MNS-Academy-Programma.pdf';
      document.body.appendChild(anchor);
      anchor.click();
      anchor.remove();
      setTimeout(() => URL.revokeObjectURL(objectUrl), 60000);
      status.textContent = 'Download avviato. Puoi anche aprire il PDF per consultarlo.';
    } catch {
      status.textContent = 'Il download diretto non è disponibile. Usa “Apri il PDF” e il comando di download del lettore.';
    } finally {
      clearTimeout(timer);
      link.removeAttribute('aria-busy');
    }
  });
})();
